// 覚醒王の噛みを「顔が主人公に被らない間合い」から出す (2026-10-27)。配布版の既定 = keep (10-27 作者「広い舞台＋下がって構える版を配布版に」)。
//   開発版の見比べ: ?awokenBiteSpace=off 旧 (近くても噛む)・=pick 近い時は噛みを選ばないだけ。
//   作者 (10-27・首を引く絵の版への答え)「これは絶対に駄目。戦闘の好みの距離を調整することでこの問題を解決することはできない？
//   無理なら下がりながら戦うのを推奨するしかないかな？」
//   暴噛・溜め噛みの予備動作の顔は boss.x から前へ 112〜125px。主人公の中心から 40px 手前に顔があれば重ならない = 165px。
//   =pick: 暴噛・溜め噛みは 170px より近ければ選ばない (連噛・突進などを選ぶ)。歩いて下がりはしない。
//   =keep: 好みの距離を 235px にする = 待機ごとに 235px まで歩いて下がってから技に入り、暴噛・溜め噛みは 225px より近ければ選ばない。
//          225 = 165 + 暴噛の溜め 480ms の間に主人公が歩いて詰める距離 (120px/s × 0.48 = 58)。溜め噛み (1300ms・詰めると 156px) は
//          どの距離から出しても、詰め続ける主人公には予備動作の後半で顔が被る (届く一番遠い所 307px より外が要る)。
//   当たり・踏み込み・時刻・絵は変えない (噛みは口が主人公に重なる所まで、最大 150〜160px 踏み込む)。
//   測った数 = docs/research/2026-10-27-awoken-bite-spacing.md
export type AwokenBiteSpaceMode = 'off' | 'pick' | 'keep'
const POCKET_PX: Record<Exclude<AwokenBiteSpaceMode, 'off'>, number> = { pick: 170, keep: 225 }
export const AWOKEN_BITE_SPACE_KEEP_PX = 235

let mode: AwokenBiteSpaceMode = 'keep'
/** DEV の切り替え (game.ts)。 */
export function setAwokenBiteSpace(v: string | null): AwokenBiteSpaceMode {
  mode = v === 'pick' || v === 'off' ? v : 'keep'
  return mode
}
export function awokenBiteSpaceMode(): AwokenBiteSpaceMode { return mode }
/** 比較版の時だけ、暴噛・溜め噛みを選ばない近さ。それ以外は undefined。 */
export function awokenBiteSpacePocketPx(attackId: string): number | undefined {
  return mode !== 'off' && (attackId === 'feralBite' || attackId === 'feralBiteDelayed') ? POCKET_PX[mode] : undefined
}
/** =keep の時だけ、待機ごとに歩いて下がって取る距離。 */
export function awokenBiteSpaceRoomPx(): number | undefined {
  return mode === 'keep' ? AWOKEN_BITE_SPACE_KEEP_PX : undefined
}
/** 開発版 =pick の時だけ、連の2拍目以降の暴噛・溜め噛みが近すぎれば true (連をそこで切る)。覚醒王以外は false。
 *  配布版 (=keep) では切らない (2026-11-01)。1発目の噛みは主人公の目の前 (約 116px) で終わるので、keep の 225px で切ると
 *  「噛み2回」「噛み・噛み・突進」の2発目が毎回消えていた (10-27 から)。作者 11-01「噛みつきの攻撃が1回の時と2連の時が
 *  あったはずなんだけど、2連が出なくなっていると思う」。2発目の構えの顔は主人公に被る (10-27 の調べのとおり) が、連の2連を優先する。 */
export function awokenBiteSpaceCutsBeat(boss: { id: string, x: number }, player: { x: number }, attackId: string): boolean {
  const min = boss.id === 'crowned-king-awoken' && mode === 'pick' ? awokenBiteSpacePocketPx(attackId) : undefined
  return min !== undefined && Math.abs(player.x - boss.x) < min
}
